/**
 * FallbackTile — rendered when the tile's `kind` isn't in the
 * registry. Keeps the canvas working even when an older dashboard
 * meets a newer server (marketplace-installed kinds, Phase C kinds
 * before their bodies land).
 */
import type { TileBodyProps } from "../registry";

export function FallbackTile({ data }: TileBodyProps) {
  const preview = JSON.stringify(data, null, 2);
  return (
    <div className="flex h-full flex-col gap-2 text-[12.5px]">
      <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-fg-faint">
        unknown tile kind
      </div>
      <p className="text-fg-muted">
        Body component for this tile kind is not registered. The data
        is shown below so you can still see what the agent pushed.
      </p>
      <pre className="flex-1 overflow-auto border border-border bg-bg-sunken p-2 font-mono text-[11px] text-fg">
        {preview || "{}"}
      </pre>
    </div>
  );
}
